import "./Logs.css";

import { RootState, useAppDispatch, useAppSelector } from "../../../../store";
import {
  collection,
  getFirestore,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";

import { Log } from "../../../../model/model";
import LogItem from "./LogItem";
import React from "react";
import { adminActions } from "../../../../store/slices/adminSlice";

export default function Logs() {
  const [type, setType] = React.useState("all");
  const [kind, setKind] = React.useState("all");
  const logs = useAppSelector((state: RootState) => state.admin.logs);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    const db = getFirestore();
    const logsCollection = collection(db, "logs");

    // Build Firestore query with filters and limit
    const logsQuery = query(
      logsCollection,
      ...(type !== "all" ? [where("type", "==", type)] : []),
      ...(kind !== "all" ? [where("kind", "==", kind)] : []),
      orderBy("date", "desc"), // Sort by date in descending order (newest first)
      limit(100)
    );

    // Set up Firestore real-time listener
    const unsubscribe = onSnapshot(
      logsQuery,
      (snapshot) => {
        const logsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          key: doc.id,
        })) as Log[];
        dispatch(adminActions.setLogs(logsData));
      },
      (error) => {
        console.error("Error in Firestore listener:", error);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [dispatch, type, kind]);

  if (!logs) return null;

  const list = [...logs];

  return (
    <div className="log-content">
      <div className="log-filters">
        Type:
        <select
          value={type}
          onChange={(e) => {
            setType(e.target.value);
          }}
        >
          <option value="all">All</option>
          <option value="info">Info</option>
          <option value="warn">Warning</option>
          <option value="error">Error</option>
          <option value="debug">Debug</option>
        </select>
        Kind:
        <select
          value={kind}
          onChange={(e) => {
            setKind(e.target.value);
          }}
        >
          <option value="all">All</option>
          <option value="user">User</option>
          <option value="exam">Exam</option>
          <option value="order">Order</option>
          <option value="login">Login</option>
          <option value="course">Course</option>
          <option value="generic">Generic</option>
        </select>
      </div>
      <div className="log-list">
        {list.map((log) => (
          <LogItem key={log.key} log={log} />
        ))}
      </div>
    </div>
  );
}
